import script from "./RecentInvoicesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentInvoicesTable.vue?vue&type=script&setup=true&lang=js"

import "./RecentInvoicesTable.vue?vue&type=style&index=0&id=3c5a467a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5a467a"]])

export default __exports__